<template>
  <b-button-group
    class="float-right">
    <b-button
      title="Download Format"
      class="btn grey outline"
      @click="onClickDownload">
      <i class="fa fa-download"/>
    </b-button>
    <b-button
      class="btn grey outline"
      @click="handleUploadBtnClick">
      <slot/>
    </b-button>
    <input
      :id="uploadInputId"
      :accept="accept"
      multiple
      type="file"
      class="c-hide"
      @change="saveFiles">
  </b-button-group>
</template>

<script>
import XLSX from 'xlsx';

export default {
  name: 'JXlsxTable',
  props: {
    accept: {
      type: String,
      default: '.xlsx, .xls',
    },
    requiredColumns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      rawFile: null,
      workbook: null,
      tableData: {
        header: [],
        body: [],
      },
      uploadInputId: (new Date().getUTCMilliseconds()),
      files: [],
      index: 0,
      count: 1,
    };
  },
  computed: {
    rABS() {
      return window.xlsxEventBus.XLSX_EVENTS_DATA.options.rABS;
    },
  },
  methods: {
    onClickDownload() {
      this.$emit('onClickDownload');
    },
    saveFiles(e) {
      const files = e.target.files;
      this.$emit('get-files', files);
      const index = Array.from(files).length - 1;
      this.handleFileChange(files, index);
    },
    modify_worksheet_range(sheet) {
      const worksheet = sheet;
      /* get the range */
      const range = XLSX.utils.decode_range(worksheet['!ref']);
      /* skip n rows */
      range.s.r += 1;
      if (range.s.r >= range.e.r) range.s.r = range.e.r;
      /* update range */
      worksheet['!ref'] = XLSX.utils.encode_range(range);
      return worksheet;
    },
    get_header_row(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r; /* start in the first row */
      let mergeCellName = '';
      /* walk every column in the range */
      for (C = range.s.c; C <= range.e.c; C += 1) {
        const cell = sheet[
          XLSX.utils.encode_cell({ c: C, r: R })
        ]; /* find the cell in the first row */

        const nextRowCell = sheet[
          XLSX.utils.encode_cell({ c: C, r: R + 1 })
        ]; /* find the cell in the first row */

        let hdr = `MERGE ${C}`; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);

        let subhdr = 'EMPTY';
        if (nextRowCell && nextRowCell.t) subhdr = XLSX.utils.format_cell(nextRowCell);

        if (!hdr.includes('MERGE') && !subhdr.includes('EMPTY')) {
          mergeCellName = hdr;
          hdr = `${hdr}__${subhdr}`;
        }

        if (hdr.includes('MERGE')) {
          hdr = `${mergeCellName}__${XLSX.utils.format_cell(nextRowCell)}`;
        }
        headers.push(hdr);
      }
      return headers;
    },
    handleFileChange(files, index) {
      if (this.rawFile !== null) {
        return;
      }
      this.rawFile = files[index];
      this.fileConvertToWorkbook(this.rawFile)
        .then((workbook) => {
          let worksheet = workbook.Sheets[workbook.SheetNames[0]];
          // get header for sheet_to_json parameter
          const newHeader = {
            header: this.get_header_row(worksheet).map((element) => {
              let item = element;
              if (element.includes(' ')) {
                item = element.replace(' ', '_');
              }
              return item;
            }),
          };
          // modify worksheet range to skip first row
          worksheet = this.modify_worksheet_range(worksheet);

          const csvArr = XLSX.utils.sheet_to_csv(worksheet, newHeader);
          const wb = XLSX.read(csvArr, { type: 'binary', cellDates: true });
          const xlsxArr = XLSX.utils.sheet_to_json(wb.Sheets.Sheet1, newHeader, { raw: true });
          xlsxArr.map((element) => {
            const item = element;
            Object.entries(element).forEach((key) => {
              if (key[0].includes('date') || key[0].includes('year') || key[0].includes('occur')) {
                if (typeof key[1] === 'object') {
                  item[key[0]] = this.$moment(key[1]).format('YYYY-MM-DD');
                }
              }
            });
            return item;
          });
          this.workbook = workbook;
          this.initTable(
            this.xlsxArrToTableArr(xlsxArr, newHeader.header),
          );
        })
        .catch(() => {
        });
      this.count += 1;
    },
    fileConvertToWorkbook(file) {
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        try {
          reader.onload = (renderEvent) => {
            const data = renderEvent.target.result;
            /* if binary string, read with type 'binary' */
            resolve(XLSX.read(data, { type: 'binary', cellDates: true, cellText: true }));
          };
          reader.onerror = (error) => {
            reject(error);
          };
          reader.readAsBinaryString(file);
        } catch (error) {
          reject(error);
        }
      });
    },
    xlsxArrToTableArr(xlsxArr, header) {
      const tableArr = [];
      // let length = 0;
      // let maxLength = 0;
      // let maxLengthIndex = 0;
      // xlsxArr.forEach((item, index) => {
      //   length = Object.keys(item).length;
      //   if (maxLength < length) {
      //     maxLength = length;
      //     maxLengthIndex = index;
      //   }
      // });
      // const tableHeader = Object.keys(xlsxArr[maxLengthIndex]);
      const tableHeader = header;
      const maxLength = header.length;
      let rowItem = {};
      xlsxArr.forEach((item) => {
        rowItem = {};
        for (let i = 0; i < maxLength; i += 1) {
          rowItem[tableHeader[i]] = item[tableHeader[i]] || '';
        }
        tableArr.push(rowItem);
      });
      return {
        header: tableHeader,
        data: tableArr,
      };
    },
    tableArrToXlsxArr({ data, header }) {
      const xlsxArr = [];
      let tempObj = {};
      data.forEach((rowItem) => {
        tempObj = {};
        rowItem.forEach((item, index) => {
          tempObj[header[index]] = item;
        });
        xlsxArr.push(tempObj);
      });
      return xlsxArr;
    },
    initTable({ data, header }) {
      let validate = true;
      if (header.length !== this.requiredColumns.length) {
        validate = false;
      } else {
        for (let i = 0; i < this.requiredColumns.length; i += 1) {
          const idx = header.findIndex(head => head === this.requiredColumns[i]);
          if (idx === -1) {
            validate = false;
            break;
          } else {
            validate = true;
          }
        }
      }
      if (validate) {
        this.tableData.header = header;
        this.tableData.body = data;
        this.$emit('on-select-file', this.tableData);
      } else {
        this.$emit('on-select-file', null);
      }
    },
    handleUploadBtnClick() {
      this.clearAllData();
      document.getElementById(this.uploadInputId).click();
    },
    clearAllData() {
      document.getElementById(this.uploadInputId).value = null;
      this.tableData = {
        header: [],
        body: [],
      };
      this.rawFile = null;
      this.workbook = null;
    },
  },
};
</script>

<style lang="scss">
.c-hide{
  display: none;
}
.vue-xlsx-container{
  display: inline-block;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  *{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .c-hide{
    display: none;
  }
}
.xlsx-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  border: 1px solid #20a0ff;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  padding: 7px 9px;
  font-size: 12px;
  border-radius: 4px;
  color: #fff;
  background-color: #20a0ff;
  &.button-large{
    padding: 10px 15px;
    font-size: 14px;
  }
  &.button-primary{
    color: #1f2d3d;
    border: 1px solid #bfcbd9;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/import/jXlsxTable.vue